import '@aws-amplify/ui-react/styles.css';
import { Amplify } from 'aws-amplify';
import { Buffer } from 'buffer';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import awsExports from './aws-exports';
import ErrorPage from './common-components/error-components/error-page/error-page';
import './index.scss';
import AppThemeProvider from './mui-themes/app-theme-provider';
import reportWebVitals from './reportWebVitals';
import RequireAuth from './require-auth';
import store from './store';

// Buffer exists in browser context, but gets confused in 'npm start' transpilation
window.Buffer = window.Buffer || Buffer;

// Amplify configuration (v6)
Amplify.configure(awsExports);

// safe check to default to error page if environment isn't 'production'
const errorElement =
  process.env.REACT_APP_SHOW_CUSTOM_ERROR_PAGE === 'true' ? (
    <ErrorPage />
  ) : undefined;

const router = createBrowserRouter([
  {
    path: '/*',
    lazy: async () => {
      const App = (await import('./App')).default;
      return {
        Component: () => (
          <RequireAuth>
            <App />
          </RequireAuth>
        ),
      };
    },
    errorElement,
  },
]);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <AppThemeProvider>
        <RouterProvider router={router} />
      </AppThemeProvider>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
